import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import {AudioRecorder} from "../../AudioRecorder";

interface AudioFieldProps {
    onChange;
    name;
    type?;
    value?;
}

@observer export class AudioField extends Component<AudioFieldProps, any> {

    render() {
        console.log(this.props);

        return <>
            <AudioRecorder value={this.props.value} onChange={this.props.onChange} />
        </>
    }

}
